export const saodKeys = {
  base: ['saod'],
  forFirm: (firmID: string | undefined | null, includeEstateStatus = false) => [
    ...saodKeys.base,
    'forFirm',
    firmID,
    { includeEstateStatus },
  ],
};
